module.exports = __webpack_public_path__ + "static/img/XYZ.b35f0da1.jpg";